import { Drop } from '@/types/Drop';

export const getItemDropSourceLink = (drop: Drop) => {
    if (drop.source === 'gift') return '/event';
    if (drop.source === 'contract') return '/contract';
    if (drop.source === 'upgrade') return '/upgrade';

    return drop.case ? '/case/' + drop.case.id : '/event';
};
